import React from 'react';
import WavyLines from '../wavy-lines';
import DownloadDropdown from './DownloadDropdown';
// import OfferBanner from './OfferBanner';

const PersonalisedReport = () => {
  const images = ['pip-01.png', 'pip-02.png', 'pip-03.png', 'pip-04.png', 'pip-05.png', 'pip-06.png'];

  return (
    <>
      <div className="relative w-full bg-[#2a9c8e14]">
        <div className="bottom-0 left-0 z-0 hidden w-full md:absolute md:block">
          <WavyLines />
        </div>
        <div className="px-6 py-12 xl:px-44">
          <div className="mx-auto flex max-w-7xl flex-col gap-4 md:flex-row md:items-start md:justify-between md:gap-12">
            <div className="order-0 z-10 w-full flex-1 md:order-none md:w-[60%]">
              <div className="grid grid-cols-3 gap-2 md:grid-cols-2 lg:grid-cols-3">
                {images.map((src, index) => {
                  const hideOnTablet = index >= 4;
                  return (
                    <div key={index} className={hideOnTablet ? 'md:hidden lg:block' : ''}>
                      <img
                        src={`/images/report/${src}`}
                        alt={`Report page ${index + 1}`}
                        className="size-full rounded-sm object-cover shadow-[0_0_10px_0_rgba(21,53,66,0.15)]"
                      />
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="order-1 flex-1 text-left md:order-none lg:max-w-[416px]">
              <h2 className="text-2xl font-bold lg:text-4xl xl:text-5xl">Your personalised Improvement Plan</h2>
              <p className="mt-2 leading-[28px] lg:mt-6">
                After your Energy Assessment, you’ll receive a detailed Improvement Plan and Thermal Imaging Report,
                created by our retrofit experts.
              </p>
              <p className="mt-4 leading-[28px]">
                These reports provide tailored guidance and visual insights to help you make informed decisions about
                how to improve your EPC rating and energy efficiency.
              </p>
              <p className="font-jost mt-2 font-medium lg:mt-6 lg:text-xl">
                All for £195 which gets refunded if you choose us to install your home upgrades.{' '}
              </p>
              <DownloadDropdown />
            </div>
          </div>
        </div>
      </div>
      {/* <OfferBanner /> */}
    </>
  );
};

export default PersonalisedReport;
